module.exports = __webpack_public_path__ + "img/xiu.c619c945.png";